var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldVideoTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14c-1.06 0-2.04.37-2.81.99A4.448 4.448 0 0 0 14 18.5c0 1.41.64 2.66 1.65 3.48.77.64 1.77 1.02 2.85 1.02 1.14 0 2.17-.43 2.97-1.12A4.52 4.52 0 0 0 23 18.5c0-1.08-.38-2.08-1.02-2.85A4.46 4.46 0 0 0 18.5 14zm.67 5.42-1.41.84c-.12.07-.25.11-.39.11-.25 0-.5-.13-.64-.36-.21-.36-.1-.82.26-1.03l1.04-.62V17.1c0-.41.34-.75.75-.75s.75.34.75.75v1.68c0 .26-.14.51-.36.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.73 2.5c0-.28-.22-.5-.5-.5H9.77c-.28 0-.5.22-.5.5v3.36c0 .28.22.5.5.5h4.46c.28 0 .5-.22.5-.5V2.5zM2.289 5.7c-.1.33.14.66.48.66h4.5c.28 0 .5-.22.5-.5V2.52a.5.5 0 0 0-.52-.5c-2.56.16-4.31 1.48-4.96 3.68zM21.71 5.689c.1.33-.14.66-.48.66h-4.5c-.28 0-.5-.22-.5-.5v-3.34a.5.5 0 0 1 .52-.5c2.56.16 4.31 1.48 4.96 3.68zM22 12.74c0 .37-.39.61-.72.44a6.013 6.013 0 0 0-7.08 1.13 5.94 5.94 0 0 0-1.7 4.19c0 .81.32 1.85.72 2.72.16.35-.08.78-.47.78H7.81C4.6 22 2 19.4 2 16.19V8.36c0-.28.22-.5.5-.5h19c.28 0 .5.22.5.5v4.38z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldVideoTime);
export default __webpack_public_path__ + "static/media/vuesax-bold-video-time.40fc60db4a28ecb260bac71a968bdc52.svg";
export { ForwardRef as ReactComponent };